import { api } from 'helpers/api'
import { useMutation } from 'react-query'

export const useAddBookmark = () => {
    return useMutation({
        mutationFn: api.bookmark.addBookmark,
    })
}
